import React, { useState } from 'react';
import { useColor } from "../../contexts/ColorContext";
import classNames from "classnames";
import { Button } from "react-bootstrap";
import 'react-tooltip/dist/react-tooltip.css';
import AddGradingSystem from "../modals/add/AddGradingSystem";

export type GradingItemMode = 'grading_scheme' | 'rubric';

interface NewGradingSystemProps {
    className?: string;
    style?: React.CSSProperties;
    mode?: GradingItemMode;
    existingNames?: string[];
    templateNames?: string[];
    onAdded?: (data: any) => void;
}

const modeLabels: Record<GradingItemMode, { addLabel: string; createTitle: string }> = {
    grading_scheme: { addLabel: 'Add a new grading scheme', createTitle: 'Create Grading Scheme' },
    rubric: { addLabel: 'Add a new rubric', createTitle: 'Create Rubric' },
};

const NewGradingSystem: React.FC<NewGradingSystemProps> = ({
    className,
    style,
    mode = 'grading_scheme',
    existingNames = [],
    templateNames = [],
    onAdded
}) => {
    const [showNewGradingSystem, setShowNewGradingSystem] = useState<boolean>(false);
    const { colors } = useColor();
    const cardStyle: React.CSSProperties = {
        ...style,
        minWidth: '150px',
        borderRadius: '8px',
        padding: `12px 16px`,
        backgroundColor: colors.white
    };
    const cardClasses = classNames(
        className,
        'd-flex',
        'flex-column'
    );

    return (
        <>
            <div className={cardClasses} style={cardStyle}>
                <div className='font-sm font-bold text-center mt-1'>
                    {modeLabels[mode].addLabel}
                </div>

                <Button
                    onClick={() => {
                        setShowNewGradingSystem(true);
                    }}
                    className='mt-2 align-self-center font-bold'
                    style={{
                        backgroundColor: colors.alternatePrimary,
                        borderRadius: '17px',
                        width: '68px'
                    }}>
                    Add
                </Button>
            </div>
            <AddGradingSystem show={showNewGradingSystem}
                mode={mode}
                actionTitle={modeLabels[mode].createTitle}
                existingNames={existingNames}
                templateNames={templateNames}
                onAdded={(data: any) => {
                    if (onAdded) onAdded(data);
                }}
                onHide={() => { setShowNewGradingSystem(false); }} />
        </>
    );
};

export default NewGradingSystem;
